.style_RoomsInfoCard__16h303d0 {
  padding: var(--_164xfge1x) var(--_164xfge1t);
  border-radius: var(--_164xfge20);
}
.style_PublicRoomsError__16h303d1 {
  padding: var(--_164xfge1t);
  border-radius: var(--_164xfge20);
}